import { useMemo, useState } from 'react'
import { Accordion, Button, Image } from 'react-bootstrap'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

import IconDownload from '../../assets/images/icons/download.svg'
import { SERVER_DATA } from '../../core/constants/app'
import { downloadZipPhotos, getPhotosVehicle } from '../../utils/invoice'
import useAppContext from '../app'

const PhotosDesktop = ({ onShowPhoto, vehicle }) => {
	const { setIsLoading } = useAppContext()
	const showPhotos = (index) => {
		onShowPhoto(vehicle, index)
	}

	const [activeKey, setActiveKey] = useState(null)

	const photos = useMemo(() => {
		return getPhotosVehicle(vehicle)
	}, [vehicle])

	if (photos.length <= 0) return null

	return (
		<div className='py-3 border-top'>
			<Accordion
				activeKey={activeKey}
				onSelect={setActiveKey}
				className='text-end'
			>
				<Accordion.Toggle
					as={Button}
					variant='default'
					eventKey='0'
					className='ms-auto fs-sub text-primary text-uppercase fw-bold'
				>
					{activeKey && (
						<>
							Hide photos (6)
							<FaChevronUp size={14} className='ms-2' />
						</>
					)}
					{!activeKey && (
						<>
							See Photos (6)
							<FaChevronDown size={14} className='ms-2' />
						</>
					)}
				</Accordion.Toggle>
				<Accordion.Collapse eventKey='0'>
					<div>
						<div className='p-4 text-start d-grid grid-auto-columns grid-template-areas-4 grid-gap-4'>
							{photos.map((photo, index) => {
								return (
									<div key={photo.date}>
										<div>
											<Image
                					src={`${SERVER_DATA}/${photo.url}`}
													className='w-100'
													onClick={() => showPhotos(index)}
												/>
											</div>
											<div className='py-3 text-center'>{photo.name}</div>
										</div>
									)
								})}

							</div>

							<div className='text-center'>
								<Button
									variant='default'
									className='ms-auto text-primary text-uppercase fs-small fw-bold'
									onClick={() => {
										setIsLoading(true)
										downloadZipPhotos(vehicle, () => {
											setIsLoading(false)
										})
									}}
								>
									Download all photos
                	<Image src={IconDownload} className='ms-2' />
								</Button>
							</div>
						</div>
					</Accordion.Collapse>
				</Accordion>
			</div>
	)
}

export default PhotosDesktop
